export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21')
];

export const server_loads = [0];

export const dictionary = {
		"/": [2],
		"/api-endpoints/contacts": [3],
		"/api-endpoints/messages": [4],
		"/api-endpoints/responses": [5],
		"/autentizace": [6],
		"/chybove-stavy": [7],
		"/datove-typy": [8],
		"/id-zaznamu": [9],
		"/identifikace": [10],
		"/limity-pozadavku": [11],
		"/odpovedi": [12],
		"/ukazkova-integrace/odeslani-pruzkumu-e-mailem": [13],
		"/ukazkova-integrace/stazeni-odpovedi-pruzkumu": [14],
		"/ukazkova-integrace/zpracovani-odpovedi-pruzkumu-v-realnem-case": [15],
		"/webhooks/co-jsou-to-webhooky": [16],
		"/webhooks/dorucovani-webhooku": [17],
		"/webhooks/nastaveni-webhooku": [18],
		"/webhooks/webhook-obdrzeni-odpovedi": [19],
		"/webhooks/webhook-spusteni-pruzkumu": [20],
		"/webhooks/webhook-ukonceni-pruzkumu": [21]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';